import React, { useState, useParams } from 'react'
import { Button, Modal, Row, Col, Form, Alert } from 'react-bootstrap'
import { exportDocumentService, authService } from '../../_services'
import { faFilePowerpoint, faFileExcel, faFileWord, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from "react-i18next"
import { SERVER_URL } from '../../config';

function ExportDocumentButton({uuid, photos, exportDocumentConfiguration}) {

	const [email, setEmail] = useState('')
	const [validated, setValidated] = useState(false)
    const [show, setShow] = useState(false)
    const { t } = useTranslation('common')

    const downloadExportDocumentByConfiguration = (configuration) => {
        console.log('downloadExportDocumentByConfiguration')
		let userId = authService.getCurrentUser().id
		console.log(photos.length)
		if (photos.length <= 100) {
			window.location.href = SERVER_URL + '/documentation/downloadExportDocument/' + uuid + '?configuration=' + configuration + '&userId=' + userId
		} else {
			setShow(true)
		}
    }

    const onClick = () => {
        setValidated(false)
        setShow(true)
    }

    const handleSubmit = (event) => {
	    event.preventDefault()
	    const form = event.currentTarget
	    if (form.checkValidity() === false) {
	        event.stopPropagation()
	        setValidated(true)
	    } else {
	        handleConfirm()
			setValidated(false)
	    }
	}

	const handleConfirm = () => {
        handleClose()

        let userId = authService.getCurrentUser().id

        exportDocumentService.createExportDocumentJob(uuid, exportDocumentConfiguration.id, email).then(result => {
			console.log(result)
        })
    }

    const handleClose = () => {
		setShow(false)
		document.body.className = ""
		document.body.style = '';
    }

    return (
        <>
            <Button variant="outline-dark" onClick={e => downloadExportDocumentByConfiguration(exportDocumentConfiguration.id)}>
				{ exportDocumentConfiguration.type == 'POWERPOINT' &&
					<FontAwesomeIcon icon={faFilePowerpoint} style={{color: '#d04423'}}/>
				}
				{ exportDocumentConfiguration.type == 'EXCEL' &&
					<FontAwesomeIcon icon={faFileExcel} style={{color: '#1f6e43'}}/>
				}
				{ exportDocumentConfiguration.type == 'WORD' &&
					<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/>
				}
				{ exportDocumentConfiguration.type == 'PDF' &&
					<FontAwesomeIcon icon={faFilePdf} style={{color: '#f70000'}}/>
				}
				{ exportDocumentConfiguration.type == 'WORD_TO_PDF' &&
					<FontAwesomeIcon icon={faFilePdf} style={{color: '#f70000'}}/>
				}
				&nbsp;{exportDocumentConfiguration.name}
			</Button>
			<Button variant="outline-dark" onClick={e => setShow(true)} style={{ display: 'none' }}>
				{ exportDocumentConfiguration.type == 'POWERPOINT' &&
					<FontAwesomeIcon icon={faFilePowerpoint} style={{color: '#d04423'}}/>
				}
				{ exportDocumentConfiguration.type == 'EXCEL' &&
					<FontAwesomeIcon icon={faFileExcel} style={{color: '#1f6e43'}}/>
				}
				{ exportDocumentConfiguration.type == 'WORD' &&
					<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/>
				}
				{ exportDocumentConfiguration.type == 'PDF' &&
					<FontAwesomeIcon icon={faFilePdf} style={{color: '#f70000'}}/>
				}
				{ exportDocumentConfiguration.type == 'WORD_TO_PDF' &&
					<FontAwesomeIcon icon={faFilePdf} style={{color: '#f70000'}}/>
				}
				&nbsp;{exportDocumentConfiguration.name}
			</Button>
	        <Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={show}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={handleClose}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>{exportDocumentConfiguration.name}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form id="data-form" noValidate onSubmit={handleSubmit} validated={validated}>
						<div style={{marginBottom: 20}}>
							{t('documentation.exportdocument.message')}
						</div>
						<Form.Group controlId="email">
							<Form.Label>
								{t('documentation.exportdocument.email')}
							</Form.Label>
			                <Form.Control
			                    type="email"
			                    name="email"
			                    value={email}
			                    onChange={e => setEmail(e.target.value)}
			                    required={true}
			                />
			            </Form.Group>
		            </Form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						{t('crudtable.cancel')}
					</Button>
					<Button form='data-form' type="submit" variant="primary">
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
        </>
    )
}

export default ExportDocumentButton